import {
  ID,
  ListApiResponse,
  SingleApiResponse,
  unwrapApiErrorDetails
} from '@ianesthesie-kit/services';
import {
  AssignedQuestionnaireDto,
  FetchAssignedQuestionnairesParams,
  QuestionnaireInconsistenciesResponse,
  QuestionnaireType
} from './questionnaire.model';
import axios from 'axios';
import { toKebabQuery } from '@/util';
import { removeEmptyValues } from '@ianesthesie-kit/core';

export class QuestionnaireService {
  private static INSTANCE_BY_ID: QuestionnaireService;

  private readonly patientId?: ID;
  private readonly url;

  private constructor(patientId: ID) {
    this.url = `/bff/doctor/patient/${patientId}/surgical-event/active/questionnaire`;
    this.patientId = patientId;
  }
  public static getInstance(patientId: ID): QuestionnaireService {
    if (this.shouldCreateNewInstance(this.INSTANCE_BY_ID, patientId)) {
      this.INSTANCE_BY_ID = new QuestionnaireService(patientId);
    }
    return this.INSTANCE_BY_ID;
  }

  protected static shouldCreateNewInstance(
    instance: QuestionnaireService,
    patientId: ID
  ): boolean {
    if (!patientId) {
      throw new Error('Patient id must be provided');
    }
    return !instance || instance.patientId !== patientId;
  }

  public fetchAssignedQuestionnaires(
    params?: FetchAssignedQuestionnairesParams
  ): Promise<{ data: AssignedQuestionnaireDto[] }> {
    if (params?.status && !Array.isArray(params.status)) {
      params.status = [params.status];
    }
    const qs = toKebabQuery(removeEmptyValues(params ?? {}));
    return axios
      .get<ListApiResponse<AssignedQuestionnaireDto>>(
        `${this.url}/assigned${qs}`
      )
      .then((resp) => ({
        data: resp.data.data
      }))
      .catch((err) => {
        throw unwrapApiErrorDetails(err) || err;
      });
  }

  public fetchQuestionnaireInconsistencies(
    questionnaireType: QuestionnaireType
  ): Promise<{ data: QuestionnaireInconsistenciesResponse }> {
    return axios
      .get<SingleApiResponse<QuestionnaireInconsistenciesResponse>>(
        `${this.url}/inconsistencies?questionnaire-type=${questionnaireType}`
      )
      .then((resp) => ({
        data: {
          ...resp.data.data,
          inconsistencies: resp.data.data.inconsistencies
            .concat()
            .sort((a, b) => b.penalty - a.penalty)
        }
      }))
      .catch((err) => {
        throw unwrapApiErrorDetails(err) || err;
      });
  }
}
